import Component from "gia/Component";
import Ukiyo from "ukiyojs";
import Env from "../base/env";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    if (Env.mobileCSS == false) {
      this.parallax = new Ukiyo(this.DOM.view, {
        scale: 1.2, // 1~2 is recommended
        speed: 1.1, // 1~2 is recommended
        willChange: true, // This may not be valid in all cases
      });
    }
  }

  unmount() {
    if (typeof this.parallax != "undefined") {
      this.parallax.destroy();
    }
  }
}
